import gsap from 'gsap';

export const triggerToggleClass = ( setting, timers, index ) => {
	let targets = [],
		classes = [],
		actions = [];

	setting?.settings?.forEach( ( ele, i ) => {
		targets[ i ] = document.querySelector( ele.target );
		classes[ i ] = ele.className;
		actions[ i ] = ele.action || 'add';
	} );

	const execute = () => {
		targets.forEach( ( ele, i ) => {
			if ( ele && ele.classList && actions[ i ] ) {
				ele.classList[ actions[ i ] ]( classes[ i ] );
			}
		} );
	};

	const run = () => {
		timers[ index ]?.kill();
		timers[ index ] = null;
		if ( setting.delay ) {
			timers[ index ] = gsap.delayedCall( setting.delay, execute );
		} else {
			execute();
		}
	};

	const kill = () => {
		targets = [];
		classes = [];
		actions = [];
	};

	return { run, kill };
};
